import { useSearchParams } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';

export function AuthComplete() {
  const [searchParams] = useSearchParams();
  const email = searchParams.get('email') || 'Unknown';

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0f1729] p-4">
      <title>Dixie :: Signed in</title>
      <div className="text-center max-w-md flex flex-col items-center gap-6">
        <CheckCircle className="w-16 h-16 text-green-500" />

        <div>
          <p className="text-gray-400 text-sm mb-1">Signed in as</p>
          <p className="text-white font-medium">{email}</p>
        </div>

        <p className="text-gray-500 text-sm">
          You can close this window and return to your terminal.
        </p>
      </div>
    </div>
  );
}
